import Model from 'model/model'

const SearchModel = Model.extend({
    // Check for one of the attribute values not being empty string, null, undefined etc.
    hasValues() {
        const { attributes } = this
        return Object.keys(attributes).some((key) => this._isValidSearchValue(attributes[key]))
    },

    _isValidSearchValue(value) {
        return value != null && value !== ''
    },
})

export default SearchModel
